export const userLocator = (callback, failedCallback = () => {}, isAccurate = false) => {
    if (window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition(({ coords }) => {
            callback({
                lat: coords.latitude,
                lng: coords.longitude,
                accuracy: coords.accuracy
            });
        }, failedCallback, {
            maximumAge: 0,
            ...(
                isAccurate && {
                    enableHighAccuracy: true,
                    timeout: 5000
                }
            )
        });
    }
};
